<template>
  <v-card class="import-rbu-section-template">
    <v-card-title class="justify-center">
      Import Template Warning
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <!-- {{ msg }} -->
      <div v-for="(m, i) in msg" :key="i">
        {{ getMsg(m) }}
      </div>

      <div style="margin-top: 1.2rem">
        <span style="color: red; font-size: medium"
          >Do you still want to continue the process?</span
        >
      </div>
    </v-card-text>

    <v-card-actions>
      <v-btn color="secondary" @click="$emit('submit', false)" depressed large>
        No
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="$emit('submit', true)" depressed large>
        Yes
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ImportRbuSectionTemplateWarningDialog",
  components: {},
  props: {
    msg: Array,
  },
  setup(props, { root, emit }) {
    const getMsg = function (msg) {
      let str = `Row ${msg.row}`;
      if (msg["deleted"]) {
        str += " - Deleted";
        return str;
      }

      if (msg["missing_prev_item_no"] && msg["missing_dummy_item_no"]) {
        str += " - Missing Previous Item No. and Dummy Item No.";
        return str;
      }
    };

    return {
      getMsg,
    };
  },
};
</script>
